<div class="whats-new">
  <div class="whats-new__inner">
    <div class="whats-new__inner__close" (click)="closeWhatsNew()">
      <mat-icon>close</mat-icon>
    </div>

    @if (currentUser.isVibaUser) {
      <div (click)="viewWhatsNew()" class="whats-new__inner__body">
        <mat-icon>notifications</mat-icon>
        {{ "See what's new in Viba!" | translate }}
      </div>
    }

    @if (!currentUser.isVibaUser) {
      <div (click)="viewWhatsNew()" class="whats-new__inner__body">
        <mat-icon>notifications</mat-icon>
        {{ "See what's new in Vision!" | translate }}
      </div>
    }

  </div>
</div>
